import SecondaryHDPLayout from './SecondaryHDPLayout';

export default SecondaryHDPLayout;
